import * as Objdict from "objdict"

const units = {}


units["class:blitz"] = {
    "classname": "blitz",
    "element": "lightning",
    "type": "gaurdner",

    "maxhealth": 3-1,
    "moverange": 4,
    "power": 0,

    "maxarmor": 1,
    "armortype": "steel",

    "maxhealth": 1, // !!
    "maxarmor": 0, // !!

    "element": "null",
    "maxhealth": 3,
    "maxarmor": 0,
    "className": "Thief",
    "name": "Blitz",
    "images": {
        "sprites": {
            "static": require("@frog/source/assets/images/apocalypse-tactics/units/blitz_standing.png").default,
            "idle": require("@frog/source/assets/images/apocalypse-tactics/units/blitz/idle/animation.js"),
            "run": require("@frog/source/assets/images/apocalypse-tactics/units/blitz/run/animation.js"),
            "hover": require("@frog/source/assets/images/apocalypse-tactics/units/blitz/hover/animation.js"),
            "attack": require("@frog/source/assets/images/apocalypse-tactics/units/blitz/attack/blitz_attack_0.png").default,
        }
    },
    "equippedSkills": {
        "attack1": "inflict-damage",
        "support1": "water",
    }
}

units["class:donna"] = {
    "classname": "donna",
    "element": "lightning",
    "type": "gaurdner",

    "maxhealth": 3-1,
    "moverange": 4,
    "power": 0,

    "maxarmor": 1,
    "armortype": "steel",

    "maxhealth": 1, // !!
    "maxarmor": 0, // !!

    "element": "null",
    "maxhealth": 3,
    "maxarmor": 0,
    "className": "Mercenary",
    "name": "Donna",
    "images": {
        "sprites": {
            "static": require("@frog/source/assets/images/apocalypse-tactics/units/donna_standing.png").default,
            "idle": require("@frog/source/assets/images/apocalypse-tactics/units/donna/idle/animation.js"),
            "run": require("@frog/source/assets/images/apocalypse-tactics/units/donna/run/animation.js"),
            "hover": require("@frog/source/assets/images/apocalypse-tactics/units/donna/hover/animation.js"),
            "attack": require("@frog/source/assets/images/apocalypse-tactics/units/donna/attack/donna_attack_0.png").default,
        }
    },
    "equippedSkills": {
        "attack1": "inflict-damage",
        "support1": "water",
    }
}

units["class:jasmine"] = {
    "classname": "jasmine",
    "element": "ground",
    "type": "gaurdner",

    "maxhealth": 3-1,
    "moverange": 4,
    "power": 0,

    "maxarmor": 1,
    "armortype": "steel",

    "maxhealth": 1, // !!
    "maxarmor": 0, // !!

    "element": "null",
    "maxhealth": 3,
    "maxarmor": 0,
    "className": "Fighter",
    "name": "Jasmine",
    "images": {
        "sprites": {
            "static": require("@frog/source/assets/images/apocalypse-tactics/units/jasmine_standing.png").default,
            "idle": require("@frog/source/assets/images/apocalypse-tactics/units/jasmine/idle/animation.js"),
            "run": require("@frog/source/assets/images/apocalypse-tactics/units/jasmine/run/animation.js"),
            "hover": require("@frog/source/assets/images/apocalypse-tactics/units/jasmine/hover/animation.js"),
            "attack": require("@frog/source/assets/images/apocalypse-tactics/units/jasmine/attack/jasmine_attack_0.png").default,
        }
    },
    "equippedSkills": {
        "attack1": "inflict-damage range:mid",
        "support1": "water",
    }
}

units["class:z"] = {
    "classname": "z",
    "element": "water",
    "type": "gaurdner",

    "maxhealth": 3-1,
    "moverange": 4,
    "power": 0,

    "maxarmor": 1,
    "armortype": "steel",

    "maxhealth": 1, // !!
    "maxarmor": 0, // !!

    "element": "null",
    "maxhealth": 3,
    "maxarmor": 0,
    "className": "Solider",
    "name": "Z",
    "images": {
        "sprites": {
            "static": require("@frog/source/assets/images/apocalypse-tactics/units/z_standing.png").default,
            "idle": require("@frog/source/assets/images/apocalypse-tactics/units/z/idle/animation.js"),
            "run": require("@frog/source/assets/images/apocalypse-tactics/units/z/run/animation.js"),
            "hover": require("@frog/source/assets/images/apocalypse-tactics/units/z/hover/animation.js"),
            "attack": require("@frog/source/assets/images/apocalypse-tactics/units/z/attack/z_attack_0.png").default,
        }
    },
    "equippedSkills": {
        "attack1": "inflict-damage",
        "support1": "water",
    }
}

///////////
// BUGS //
/////////

units["class:spider1"] = {
    "classname": "spider1",
    "affiliation": "bad",
    "level": 1,
    "type": "bug",

    "moverange": 4,
    "maxhealth": 1,

    "equippedSkills": {"attack1": "inflict-damage"},

    "className": "Spider",
    "images": {
        "sprites": {
            "static": require("@frog/source/assets/images/apocalypse-tactics/units/bug_standing.png").default,
            "idle": require("@frog/source/assets/images/apocalypse-tactics/units/bug_01/idle/animation.js"),
        }
    },
}
units["class:bug"] = units["class:spider1"]

units["class:spider2"] = {
    "classname": "spider2",
    "affiliation": "bad",
    "level": 2,
    "type": "bug",

    "moverange": 4,
    "maxhealth": 2,

    "equippedSkills": {"attack1": "inflict-damage"},

    "className": "Rad Spider",
    "images": {
        "sprites": {
            "static": require("@frog/source/assets/images/apocalypse-tactics/units/bug_02_standing.png").default,
            "idle": require("@frog/source/assets/images/apocalypse-tactics/units/bug_02/idle/animation.js"),
        }
    },
}

units["class:slug1"] = {
    "classname": "slug1",
    "affiliation": "bad",
    "level": 1,
    "type": "bug",

    "moverange": 2,
    "maxhealth": 1,

    "equippedSkills": {"attack1": "inflict-damage range:mid"},

    "className": "Rad Spider",
    "images": {
        "sprites": {
            "static": require("@frog/source/assets/images/apocalypse-tactics/units/slug_01_standing.png").default,
            "idle": require("@frog/source/assets/images/apocalypse-tactics/units/slug_01/idle/animation.js"),
        }
    },
}

units["class:slug2"] = {
    "classname": "slug2",
    "affiliation": "bad",
    "level": 2,
    "type": "bug",

    "moverange": 2,
    "maxhealth": 2,

    "equippedSkills": {"attack1": "inflict-damage range:mid"},

    "className": "Rad Spider",
    "images": {
        "sprites": {
            "static": require("@frog/source/assets/images/apocalypse-tactics/units/slug_02_standing.png").default,
            "idle": require("@frog/source/assets/images/apocalypse-tactics/units/slug_02/idle/animation.js"),
        }
    },
}

/////////////
// PLANTS //
///////////

units["class:bunnion"] = {
    "classname": "bunnion",
    "affiliation": "none",
    "type": "plant",
    "level": 1,

    "name": "Bunnions",
    "maxhealth": 2,
    "properties": {
        "maxlevel": 4,
        "score": 1,
    },
    "images": {
        "sprites": {
            "1": require("@frog/source/assets/images/apocalypse-tactics/environment/vegetation/Bunnion/Crop03_Bunnion_0_Seed.png").default,
            "2": require("@frog/source/assets/images/apocalypse-tactics/environment/vegetation/Bunnion/Crop03_Bunnion_1_Sprout.png").default,
            "3": require("@frog/source/assets/images/apocalypse-tactics/environment/vegetation/Bunnion/Crop03_Bunnion_2_Young.png").default,
            "4": require("@frog/source/assets/images/apocalypse-tactics/environment/vegetation/Bunnion/Crop03_Bunnion_3_Ripe.png").default,
        }
    },
}

units["class:corndog"] = {
    "classname": "corndog",
    "affiliation": "none",
    "type": "plant",
    "level": 1,

    "name": "Corndogs",
    "maxhealth": 2,
    "properties": {
        "maxlevel": 5,
        "isBlooming": true,
        "levelregress": 3,
        "score": 1,
    },
    "images": {
        "sprites": {
            "1": require("@frog/source/assets/images/apocalypse-tactics/environment/vegetation/CornDog/Crop02_CornDog_0_Seed.png").default,
            "2": require("@frog/source/assets/images/apocalypse-tactics/environment/vegetation/CornDog/Crop02_CornDog_1_Sprout.png").default,
            "3": require("@frog/source/assets/images/apocalypse-tactics/environment/vegetation/CornDog/Crop02_CornDog_1b_Flowering.png").default,
            "4": require("@frog/source/assets/images/apocalypse-tactics/environment/vegetation/CornDog/Crop02_CornDog_2_Young.png").default,
            "5": require("@frog/source/assets/images/apocalypse-tactics/environment/vegetation/CornDog/Crop02_CornDog_3_Ripe.png").default,
        }
    },
}

units["class:horseradish"] = {
    "classname": "horseradish",
    "affiliation": "none",
    "type": "plant",
    "level": 1,

    "name": "Horseradish",
    "maxhealth": 1,
    "properties": {
        "maxlevel": 3,
        "score": 1,
    },
    "images": {
        "sprites": {
            "1": require("@frog/source/assets/images/apocalypse-tactics/environment/vegetation/HorseRadish/Crop_HorseRadish_1_Sprout.png").default,
            "2": require("@frog/source/assets/images/apocalypse-tactics/environment/vegetation/HorseRadish/Crop_HorseRadish_2_Young.png").default,
            "3": require("@frog/source/assets/images/apocalypse-tactics/environment/vegetation/HorseRadish/Crop_HorseRadish_3_Ripe.png").default,
        }
    },
}

units["class:lobsterkale"] = {
    "classname": "lobsterkale",
    "affiliation": "none",
    "type": "plant",
    "level": 1,

    "name": "Lobster Kale",
    "maxhealth": 2,
    "properties": {
        "maxlevel": 4,
        "isThorny": true,
        "score": 2,
    },
    "images": {
        "sprites": {
            "1": require("@frog/source/assets/images/apocalypse-tactics/environment/vegetation/KaleLobster/Crop_LobsterKale_0_Seed.png").default,
            "2": require("@frog/source/assets/images/apocalypse-tactics/environment/vegetation/KaleLobster/Crop_LobsterKale_1_Sprout.png").default,
            "3": require("@frog/source/assets/images/apocalypse-tactics/environment/vegetation/KaleLobster/Crop_LobsterKale_2_Young.png").default,
            "4": require("@frog/source/assets/images/apocalypse-tactics/environment/vegetation/KaleLobster/Crop_LobsterKale_3_Ripe.png").default,
        }
    },
}

units["class:squidbeet"] = {
    "classname": "squidbeet",
    "affiliation": "none",
    "type": "plant",
    "level": 1,

    "name": "Squid Beets",
    "maxhealth": 3,
    "equippedSkills": {"at-end-of-turn": "curse"},
    "properties": {
        "maxlevel": 4,
        "score": 2,
    },
    "images": {
        "sprites": {
            "1": require("@frog/source/assets/images/apocalypse-tactics/environment/vegetation/SquidBeet/Crop_SquidBeet_0_Seed.png").default,
            "2": require("@frog/source/assets/images/apocalypse-tactics/environment/vegetation/SquidBeet/Crop_SquidBeet_1_Sprout.png").default,
            "3": require("@frog/source/assets/images/apocalypse-tactics/environment/vegetation/SquidBeet/Crop_SquidBeet_2_Young.png").default,
            "4": require("@frog/source/assets/images/apocalypse-tactics/environment/vegetation/SquidBeet/Crop_SquidBeet_3_Ripe.png").default,
        }
    },
}

units["class:ottermelon"] = {
    "classname": "ottermelon",
    "affiliation": "none",
    "type": "plant",
    "level": 1,

    "name": "Otter Melon",
    "maxhealth": 4,
    "properties": {
        "maxlevel": 9,
        "score": 8,
    },
    "images": {
        "sprites": {
            "1": require("@frog/source/assets/images/apocalypse-tactics/environment/vegetation/OtterMelon/Crop_OtterMelon_0_Seed.png").default,
            "2": require("@frog/source/assets/images/apocalypse-tactics/environment/vegetation/OtterMelon/Crop_OtterMelon_1_Sprout.png").default,
            "3": require("@frog/source/assets/images/apocalypse-tactics/environment/vegetation/OtterMelon/Crop_OtterMelon_1_Sprout.png").default,
            "4": require("@frog/source/assets/images/apocalypse-tactics/environment/vegetation/OtterMelon/Crop_OtterMelon_2_Flower.png").default,
            "5": require("@frog/source/assets/images/apocalypse-tactics/environment/vegetation/OtterMelon/Crop_OtterMelon_2_Flower.png").default,
            "6": require("@frog/source/assets/images/apocalypse-tactics/environment/vegetation/OtterMelon/Crop_OtterMelon_3_Young.png").default,
            "7": require("@frog/source/assets/images/apocalypse-tactics/environment/vegetation/OtterMelon/Crop_OtterMelon_3_Young.png").default,
            "8": require("@frog/source/assets/images/apocalypse-tactics/environment/vegetation/OtterMelon/Crop_OtterMelon_4_Ripe.png").default,
            "9": require("@frog/source/assets/images/apocalypse-tactics/environment/vegetation/OtterMelon/Crop_OtterMelon_4_Ripe.png").default,
        }
    },
}

units["class:kiwisquash"] = {
    "classname": "kiwisquash",
    "affiliation": "none",
    "type": "plant",
    "level": 1,

    "name": "Kiwi Squash",
    "maxhealth": 2,
    "properties": {
        "maxlevel": 5,
        "score": 2,
        "isWild": true,
    },
    "images": {
        "sprites": {
            "1": require("@frog/source/assets/images/apocalypse-tactics/environment/vegetation/KiwiSquash/Crop01_KiwiSquash_0_Seed.png").default,
            "2": require("@frog/source/assets/images/apocalypse-tactics/environment/vegetation/KiwiSquash/Crop01_KiwiSquash_1_sprout.png").default,
            "3": require("@frog/source/assets/images/apocalypse-tactics/environment/vegetation/KiwiSquash/Crop01_KiwiSquash_1b_Flowering.png").default,
            "4": require("@frog/source/assets/images/apocalypse-tactics/environment/vegetation/KiwiSquash/Crop01_KiwiSquash_2_Young.png").default,
            "5": require("@frog/source/assets/images/apocalypse-tactics/environment/vegetation/KiwiSquash/Crop01_KiwiSquash_3_Ripe.png").default,
        }
    },
}

units["class:musselsprout"] = {
    "classname": "musselsprout",
    "affiliation": "none",
    "type": "plant",
    "level": 1,

    "name": "Mussel Sprouts",
    "maxhealth": 2,
    "equippedSkills": {"at-end-of-turn": "wither"},
    "properties": {
        "maxlevel": 4,
        "score": 2,
        "isFinicky": true,
    },
    "images": {
        "sprites": {
            "1": require("@frog/source/assets/images/apocalypse-tactics/environment/vegetation/MusselSprouts/Crop_MusselSprout_1_Sprout.png").default,
            "2": require("@frog/source/assets/images/apocalypse-tactics/environment/vegetation/MusselSprouts/Crop_MusselSprout_2_YoungFresh.png").default,
            "2w": require("@frog/source/assets/images/apocalypse-tactics/environment/vegetation/MusselSprouts/Crop_MusselSprout_3_YoungWither.png").default,
            "3": require("@frog/source/assets/images/apocalypse-tactics/environment/vegetation/MusselSprouts/Crop_MusselSprout_2_YoungFresh.png").default,
            "3w": require("@frog/source/assets/images/apocalypse-tactics/environment/vegetation/MusselSprouts/Crop_MusselSprout_3_YoungWither.png").default,
            "4": require("@frog/source/assets/images/apocalypse-tactics/environment/vegetation/MusselSprouts/Crop_MusselSprout_4_Ripe.png").default,
            "4w": require("@frog/source/assets/images/apocalypse-tactics/environment/vegetation/MusselSprouts/Crop_MusselSprout_4_Ripe.png").default,
        }
    },
}

units["class:urchintomato"] = {
    "classname": "urchintomato",
    "affiliation": "none",
    "type": "plant",
    "level": 1,

    "name": "Urchin Tomato",
    "maxhealth": 1,
    "properties": {
        "maxlevel": 3,
        "isSpreading": true,
        "spreadclass": "urchintomatovine",
    },
    "images": {
        "sprites": {
            "1": require("@frog/source/assets/images/apocalypse-tactics/environment/vegetation/TomatoUrchin/Crop04_UrchinTomato_0a_Seed.png").default,
            "2": require("@frog/source/assets/images/apocalypse-tactics/environment/vegetation/TomatoUrchin/Crop04_UrchinTomato_0b_Sprout.png").default,
            "3": require("@frog/source/assets/images/apocalypse-tactics/environment/vegetation/TomatoUrchin/Crop04_UrchinTomato_0c_Vine.png").default,
            "4": require("@frog/source/assets/images/apocalypse-tactics/environment/vegetation/TomatoUrchin/Crop04_UrchinTomato_0c_Vine.png").default,
        }
    },
}

units["class:urchintomatovine"] = {
    "classname": "urchintomatovine",
    "affiliation": "none",
    "type": "plant",
    "level": 1,

    "name": "Urchin Tomato",
    "maxhealth": 2,
    "properties": {
        "maxlevel": 4,
        "score": 4,
    },
    "images": {
        "sprites": {
            "1": require("@frog/source/assets/images/apocalypse-tactics/environment/vegetation/TomatoUrchin/Crop04_UrchinTomato_1_Shoot.png").default,
            "2": require("@frog/source/assets/images/apocalypse-tactics/environment/vegetation/TomatoUrchin/Crop04_UrchinTomato_1_Sprout.png").default,
            "3": require("@frog/source/assets/images/apocalypse-tactics/environment/vegetation/TomatoUrchin/Crop04_UrchinTomato_2_Young.png").default,
            "4": require("@frog/source/assets/images/apocalypse-tactics/environment/vegetation/TomatoUrchin/Crop04_UrchinTomato_3_Ripe.png").default,
        }
    },
}

// "1": require("@frog/source/assets/images/apocalypse-tactics/environment/vegetation/TomatoUrchin/Crop04_UrchinTomato_0a_Seed.png").default,


////////////
// WORLD //
//////////

units["class:spawn-zone"] = {
    "isHidingHealthbar": true,
    "affiliation": "bad",
    "type": "zone",
    "health": 3,

    "images": {
        "sprites": {
            "static": require("@frog/source/assets/images/apocalypse-tactics/ui/x.png").default
        }
    },

    "equippedSkills": {
        "skill": "spawn"
    },
}

units["class:spawn-spawn-zone"] = {
    "isHidingHealthbar": true,
    "affiliation": "none",
    "type": "zone",
    "health": 3,
    "isNotRendered": true,
}

// units["class:escape-zone"] = {
//     "isHidingHealthbar": true,
//     "affiliation": "good",
//     "type": "zone",
//     "health": 3,
//
//     "images": {
//         "sprites": {
//             "static": require("@frog/source/assets/images/ninja-tactics/iso-pass/green-range.png").default,
//         }
//     },
//
//     "equippedSkills": {
//         "skill": "escape"
//     },
// }
//
// units["class:kill-zone"] = {
//     "isHidingHealthbar": true,
//     "affiliation": "none",
//     "type": "zone",
//     "health": 3,
//
//     "images": {
//         "sprites": {
//             "static": require("@frog/source/assets/images/hero-tactics/ui/spot-16px-a.png").default,
//         }
//     },
//
//     "intent": "kill", // can i codify this as a reaction somehow??
// }

units["class:explosive"] = {
    "isHidingHealthbar": true,
    "affiliation": "none",
    "health": 1,
    "type": "explosive", // doing this only to clock whether to recursively blow up other things.

    "images": {
        "sprites": {
            "static": require("@frog/source/assets/images/hero-tactics/ui/barrel.png").default,
        }
    },

    "skills": {
        "death-by-damage": "explode",
    }
}








import shortid from "shortid"
import Random from "@frog/source/utility/Random.js"
function getReferencedUnit(unit) {
    if(unit == undefined) {
        return {}
    }

    // Default the properties
    // that are used to index
    // the referenced unit.
    if(unit.level === undefined) {
        unit.level = 1
    }
    // if(unit.class === undefined
    // || unit.class === "") {
    //     unit.class = Random.element([
    //         "ground-fighter", "lightning-fighter", "water-fighter",
    //         "ground-ranger", "lightning-ranger", "water-ranger",
    //         "ground-mage", "lightning-mage", "water-mage",
    //     ])
    // }

    let referencedUnit = {}

    if(unit.class != undefined) {
        if(units["class:" + unit.class] != undefined) {
            referencedUnit = Objdict.merge(referencedUnit, units["class:" + unit.class])
        } else {
            throw new Error("getReferencedUnit could not find unit of class " + unit.class)
        }
    }

    // if(unit.class != undefined
    // && unit.element != undefined
    // && units["class:" + unit.class + " " + "element:" + unit.element] != undefined) {
    //     referencedUnit = Objdict.merge(referencedUnit, units["class:" + unit.class + " " + "element:" + unit.element])
    // }

    if(unit.class != undefined
    && unit.affiliation != undefined
    && units["class:" + unit.class + " " + "affiliation:" + unit.affiliation] != undefined) {
        referencedUnit = Objdict.merge(referencedUnit, units["class:" + unit.class + " " + "affiliation:" + unit.affiliation])
    }

    // if(unit.class != undefined
    // && unit.affiliation != undefined
    // && units["class:" + unit.class + " " + "element:" + unit.element + " " + "affiliation:" + unit.affiliation] != undefined) {
    //     referencedUnit = Objdict.merge(referencedUnit, units["class:" + unit.class + " " + "element:" + unit.element + " " + "affiliation:" + unit.affiliation])
    // }

    referencedUnit.reference = "class:" + unit.class + " " + "affiliation:" + unit.affiliation // TODO: ...WHY THIS SPECIFICALLY?

    referencedUnit.power = referencedUnit.power || 2
    referencedUnit.affiliation = referencedUnit.affiliation || "none"

    // if(unit.level != undefined) {
    //     referencedUnit.maxhealth = 2 + (unit.level * 1)
    //     // referencedUnit.maxhealth = unit.level * 2
    //     // referencedUnit.power = unit.level
    // }
    // if(referencedUnit.maxhealth != undefined) {
    //     if(unit.affiliation == "good") {
    //         // referencedUnit.maxhealth += 1
    //         // referencedUnit.power += 1
    //     } else if(unit.affiliation == "bad") {
    //         // referencedUnit.maxhealth -= 1
    //     }
    // }

    // unit.armor = 3
    // unit.maxarmor = 3

    return referencedUnit
}

const get = getReferencedUnit

export {units, getReferencedUnit, get}
